

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface WardParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface Ward {
    id?: number;
    tenantId: any;
    branchId: any;
    
    name:string;
    tariff:any;
    halfDayTariff:any;
    hourlyTariff:any;
    calculationMethod:string;
    //checkOutTime:string;
    //ampm:string;
    
    fromTime:Date;
    toTime:any;
    isActive:string;
    isICU:string;
    inActiveReason:string;

    //New
    peopleAllowed:any;
    facility :string;
    graceHours: any;
    mappingWardName:any;
    gstPercentage?:number;
    comboServices:string;
  parameters?: WardParameter[];
  links?: any;
}

export abstract class WardData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<Ward[]>;
  abstract create(url: string, data: Ward): Observable<Ward[]>;
  abstract update(url: string, data: Ward): Observable<Ward>;
  abstract delete(url: string): Observable<any>;
 
}
